export default ($resource) => {
    const baseUrl = `${SEED_CORE.ENV.API_URL}course/course`;
    const url = `${baseUrl}/:id`;
    return $resource(url, null, {
        create: {
            method: 'POST',
            url: `${baseUrl}`
        },
        update: {
            method: 'PUT',
            url
        },
        getCourse: {
            method: 'GET',
            url
        },
        getCourses: {
            method: 'POST',
            url: `${url}/courses`,
            isArray: true
        },
        trainingNeeds: {
            method: 'GET',
            url: `${baseUrl}/training-needs`,
            isArray: true
        },
        trainingNeedUsers: {
            method: 'GET',
            url: `${url}/training-need-users`,
            isArray: true
        },
        setTrainingNeed: {
            method: 'POST',
            url: `${url}/set-training-need`
        },
        userResultsReport: {
            method: 'POST',
            url: `${baseUrl}/user-results-report`,
            isArray: true
        },
        resultsReport: {
            method: 'POST',
            url: `${baseUrl}/results-report`,
            isArray: true
        },
        learnerProgress: {
            method: 'POST',
            url: `${baseUrl}/learner-progress`,
            isArray: true
        },
        resultsReportSummary: {
            method: 'POST',
            url: `${baseUrl}/results-report-summary`
        },
        targetsReport: {
            method: 'GET',
            url: `${url}/targets-report`,
            isArray: true
        },
        deleteImage: {
            method: 'DELETE',
            url: `${url}/delete-image`
        },
        userCourseProgressReport: {
            method: 'POST',
            url: `${baseUrl}/user-course-progress-report`,
            isArray: true
        },
        setTargetExceptions: {
            method: 'POST',
            url: `${baseUrl}/set-target-exceptions`,
            isArray: true
        },
        cloneCourse: {
            method: 'POST',
            url: `${baseUrl}/course-clone`
        }
    });
};



// WEBPACK FOOTER //
// ./src/app/resources/Course/index.js